<template>
    <div v-if="$page.props.user && !post.streamUrl">
        <!-- Review Pending Competitor Requests -->
        <!--<div v-if="post.canRequest">-->
        <div>
            <!--Submit Challenge Video-->
            <div v-if="this.isCompetitorApproved">
                <upload-challenge-button :post="post" />
                <div class="flex">
                    <hr class="flex-grow my-4 border-gray-300" />
                    <span class="flex-grow-0 place-self-center px-4 text-gray-500 text-xs uppercase">or</span>
                    <hr class="flex-grow my-4 border-gray-300" />
                </div>
            </div>

            <!--View Pending Challenge Requests-->
            <challenge-request-button v-if="hasPendingCompetitors" :href="route('challengeRequests.index', { post: post })" class="disabled:bg-yellow-200 bg-yellow-500 hover:bg-yellow-700 active:bg-yellow-800 ring-yellow-500">
                <span class="absolute left-3 inline-flex items-center mr-1 px-3 py-0.5 text-white font-medium bg-yellow-600 rounded-full">
                    <span class="flex absolute inset-0 z-0">
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-200 opacity-75"></span>
                    </span>
                    {{ post.pendingCompetitors.length }}
                </span>
                Pending {{ "video" | pluralize(post.pendingCompetitors.length) }}
            </challenge-request-button>

            <!--Quit the challenge-->
            <!--<challenge-request-button v-if="post.isCompeting" as="button" method="delete" :href="route('detachUserFromChallenge', { post: post })" class="disabled:bg-rose-200 bg-rose-500 hover:bg-rose-700 active:bg-rose-800 ring-rose-500"> Quit The Challenge </challenge-request-button>-->

            <!--Accept the challenge-->
            <div v-if="post.pledgedAmount !== 0">
                <challenge-request-button v-if="canAcceptChallenge && !post.isCompeting" as="button" method="post" :href="route('attachUserToChallenge', { post: post })" class="disabled:bg-green-200 bg-green-500 hover:bg-green-700 active:bg-green-800 ring-green-500">
                    Accept The Challenge
                </challenge-request-button>

                <!--Upload Your challenge-->
                <!--<challenge-request-button v-if="post.isChallenger" as="button" :href="route('posts.submitVideo.show', { post: post, competitor: post.competitor })" class="disabled:bg-green-200 bg-green-500 hover:bg-green-700 active:bg-green-800 ring-green-500">-->
                <!--    Complete The Challenge-->
                <!--</challenge-request-button>-->

                <div v-if="hasPendingCompetitors || canAcceptChallenge" class="flex">
                    <hr class="flex-grow my-4 border-gray-300" />
                    <span class="flex-grow-0 place-self-center px-4 text-gray-500 text-xs uppercase">or</span>
                    <hr class="flex-grow my-4 border-gray-300" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChallengeRequestButton from "@/Pages/Post/ChallengeRequestButton"
import UploadChallengeButton from "@/Pages/Post/UploadChallengeButton"

export default {
    components: { UploadChallengeButton, ChallengeRequestButton },
    props: {
        post: {
            required: true,
            type: Object,
        },
    },

    computed: {
        canAcceptChallenge() {
            if (this.post.type === "personal") return false
            if (this.post.type === "public" && this.post.isCompeting) return false
            if (this.post.type === "targeted") {
                if (this.post.isCompeting || this.post.isChallenger) {
                    return false
                }
            }
            return true
        },
        hasPendingCompetitors() {
            return this.post.pendingCompetitors && this.post.pendingCompetitors.length
        },
        isCompetitorApproved() {
            if (!this.$page.props.competitor) return false
            return this.$page.props.competitor.status === "approved"
        },
    },
}
</script>
